import React from 'react';
import { withStyles } from '@material-ui/core';
import CKEditor from 'react-ckeditor-component';

import '../common/CKEditorStyle.css';

const styles = (theme) => ({
  wordCounter: {
    backgroundColor: 'rgb(249, 249, 249)',
    borderBottom: '1px solid #c4c4c4',
    borderLeft: '1px solid #c4c4c4',
    borderRight: '1px solid #c4c4c4',
    borderBottomLeftRadius: '2px',
    borderBottomRightRadius: '2px',
    textAlign: 'right',
    padding: '0.2em 1em',
    fontWeight: 'bold',
    fontSize: '11px',
    color: '#4c4c4c',
  },
});

var g_timer = null;
var g_dateTime = new Date();

class EditorWrapper extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      delayTimer: null,
      content: this.props.content ? this.props.content : '',
      isInit: true,
    };

    this.onChangeASync = this.onChangeASync.bind(this);
    this.onChangeSync = this.onChangeSync.bind(this);
    this.onChange = this.onChange.bind(this);
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (nextProps !== this.props && this.state.isInit) {
      return true;
    }
    return false;
  }

  static getDerivedStateFromProps(props, state) {
    if (props.content !== state.content) {
      return { content: props.content, isInit: false };
    } else {
      return null;
    }
  }

  async onChangeASync(event) {
    let buff = setTimeout(() => {
      let now = new Date();
      let intval = now.getTime() - g_dateTime.getTime();
      if (this.props.delayEvent && intval > 1000) {
        // console.log(event.editor);
        this.props.delayEvent(event, event.editor, this.props.type);
      }
    }, 1000);
    g_timer = buff;
  }

  onChangeSync(event) {
    if (g_timer !== null) {
      clearTimeout(g_timer);
      g_timer = null;
    }

    g_dateTime = new Date();
    var newContent = event.editor.getData();
    this.setState({
      content: newContent,
    });
  }

  onChange(event) {
    this.onChangeSync(event);
    this.onChangeASync(event);
  }

  render() {
    return (
      <CKEditor
        content={this.state.content}
        activeClass="p10"
        events={{
          change: this.onChange,
        }}
        delayEvent={this.props.delayEvent}
      />
    );
  }
}

export default withStyles(styles, { withTheme: true })(EditorWrapper);
